import React,{useState,useEffect} from 'react'
import { StateUseContext } from '../../context/UserDetailContext';
import { upadateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

const FamilyInfo = ({nexTabChange}) => {
    const {userDetail,countryCode,setUserDetail} = StateUseContext() 

    const [fatherName,setFatherName] = useState({value:'',error:''});
    const [motherName,setMotherName] = useState({value:'',error:''});
    const [fatherEmailAddress,setFatherEmailAddress] = useState({value:'',error:''});
    const [motherEmailAddress,setMotherEmailAddress] = useState({value:'',error:''});
    const [fatherMobileNumber,setFatherMobileNumber] = useState({value:'',error:''});
    const [motherMobileNumber,setMotherMobileNumber] = useState({value:'',error:''});
    const [whatsappNumber,setWhatsappNumber] = useState({value:'',error:''});
    const [motherProfession,setMotherProfession] = useState({value:'',error:''});
    const [motherDesignation,setMotherDesignation] = useState({value:'',error:''});
    const [fatherProfession,setFatherProfession] = useState({value:'',error:''});
    const [fatherDesignation,setFatherDesignation] = useState({value:'',error:''});
    const [motherOrganization,setMotherOrganization] = useState({value:'',error:''});
    const [fatherOrganization,setFatherOrganization] = useState({value:'',error:''});

    const [concernMobileNumber,setConcernMobileNumber] = useState({value:'',error:''});
    const [operationMobileNumber,setOperationMobileNumber] = useState({value:'',error:''});
    const [concernCountryCode,setConcernCountryCode] = useState({value:'',error:''});
    const [operationCountryCode,setOperationCountryCode] = useState({value:'',error:''});

    const [whatsappCountryCode,setWhatsappCountryCode] = useState({value:'',error:''});
    const [motherCountryCode,setMotherCountryCode] = useState({value:'',error:''});  
    const [fatherCountryCode,setFatherCountryCode] = useState({value:'',error:''});


    const [loading,setLoading] = useState(false);

    const {father_name,mother_name,parent_email,mother_email,
        parent_mobile,mother_mobile,whatsapp_number,mother_profession,mother_designation,mother_company_name,
        parent_profession,parent_designation,parent_company_name,country_code,concerned_mobile_no,operational_mobile_no,
        concerned_country_code,operational_country_code,whatsapp_country_code,parent_country_code,mother_country_code,country_id} = userDetail !==undefined && userDetail
     
    useEffect(() => {
        if(userDetail !==undefined){
            setFatherName({...fatherName,value:father_name || ''})
            setMotherName({...motherName,value:mother_name || ''})
            setFatherEmailAddress({...fatherEmailAddress,value:parent_email || ''})
            setMotherEmailAddress({...motherEmailAddress,value:mother_email || ''})
            setFatherMobileNumber({...fatherMobileNumber,value:parent_mobile || ''})
            setMotherMobileNumber({...motherMobileNumber,value:mother_mobile || ''})
            setWhatsappNumber({...whatsappNumber,value:whatsapp_number || ''})
            setMotherProfession({...motherProfession,value:mother_profession || ''})
            setMotherDesignation({...motherDesignation,value:mother_designation || ''})
            setFatherProfession({...fatherProfession,value:parent_profession || ''})
            setFatherDesignation({...fatherDesignation,value:parent_designation || ''})
            setMotherOrganization({...motherOrganization,value:mother_company_name || ''})
            setFatherOrganization({...fatherOrganization,value:parent_company_name || ''})
            setConcernMobileNumber({...concernMobileNumber,value:concerned_mobile_no || ''})
            setOperationMobileNumber({...operationMobileNumber,value:operational_mobile_no || ''})
            
            setOperationCountryCode({...operationCountryCode,value:operational_country_code || '', error:''})
            setConcernCountryCode({...concernCountryCode,value:concerned_country_code || '', error:''})
            setWhatsappCountryCode({...whatsappCountryCode,value:whatsapp_country_code || '', error:''})
            setFatherCountryCode({...fatherCountryCode,value:parent_country_code || '', error:''})
            setMotherCountryCode({...motherCountryCode,value:mother_country_code || '', error:''})
        }
    },[])

    const validation = () => {
        let formIsValid = true

        if(!fatherName.value){
            formIsValid = false
            let msg = 'Enter father name'
            setFatherName({...fatherName,error:msg});
        }

        // Country code errors
        if(!fatherCountryCode.value){
            formIsValid = false
            let msg = 'Country code and mobile number are required.'
            setFatherCountryCode({...fatherCountryCode,error:msg});
        }
        if(!motherCountryCode.value){
            formIsValid = false
            let msg = 'Country code and mobile number are required.'
            setMotherCountryCode({...motherCountryCode,error:msg});
        }
        if(!whatsappCountryCode.value){
            formIsValid = false
            let msg = 'Country code and mobile number are required.'
            setWhatsappCountryCode({...whatsappCountryCode,error:msg});
        }
        if(!concernCountryCode.value){
            formIsValid = false
            let msg = 'Country code and mobile number are required.'
            setConcernCountryCode({...concernCountryCode,error:msg});
        }
        if(!operationCountryCode.value){
            formIsValid = false
            let msg = 'Country code and mobile number are required.'
            setOperationCountryCode({...operationCountryCode,error:msg});
        }


        if(!motherName.value){
            formIsValid = false
            let msg = 'Enter mother name'
            setMotherName({...motherName,error:msg});
        }
        if(!fatherEmailAddress.value){
            formIsValid = false
            let msg = 'Enter father email address'
            setFatherEmailAddress({...fatherEmailAddress,error:msg});
        }
        if(!motherEmailAddress.value){
            formIsValid = false
            let msg = 'Enter mother email address'
            setMotherEmailAddress({...motherEmailAddress,error:msg});
        }
        if(!fatherMobileNumber.value){
            formIsValid = false
            let msg = 'Enter father mobile number'
            setFatherMobileNumber({...fatherMobileNumber,error:msg});
        }

        if(!motherMobileNumber.value){
            formIsValid = false
            let msg = 'Enter mother mobile number'
            setMotherMobileNumber({...motherMobileNumber,error:msg});
        }
        if(!whatsappNumber.value){
            formIsValid = false
            let msg = 'Enter whatsapp number'
            setWhatsappNumber({...whatsappNumber,error:msg});
        }

        if(!fatherProfession.value){
            formIsValid = false
            let msg = 'Enter father profession'
            setFatherProfession({...fatherProfession,error:msg});
        }
        if(!motherProfession.value){
            formIsValid = false
            let msg = 'Enter mother profession'
            setMotherProfession({...motherProfession,error:msg});
        }
        if(!motherDesignation.value){
            formIsValid = false
            let msg = 'Enter mother designation'
            setMotherDesignation({...motherProfession,error:msg});
        }
        if(!fatherDesignation.value){
            formIsValid = false
            let msg = 'Enter father designation'
            setFatherDesignation({...fatherDesignation,error:msg});
        }
        if(!motherOrganization.value){
            formIsValid = false
            let msg = 'Enter mother organization name'
            setMotherOrganization({...motherOrganization,error:msg});
        }
        if(!fatherOrganization.value){
            formIsValid = false
            let msg = 'Enter father organization name'
            setFatherOrganization({...fatherOrganization,error:msg});
        }

        if(!concernMobileNumber.value){
            formIsValid = false
            let msg = 'Enter concern mobile number'
            setConcernMobileNumber({...concernMobileNumber,error:msg});
        }
        if(!operationMobileNumber.value){
            formIsValid = false
            let msg = 'Enter operation mobile number'
            setOperationMobileNumber({...operationMobileNumber,error:msg});
        }

            if(country_id ===1 || country_id ===2 || country_id ===4 || country_id ===5){
                
                if(concernCountryCode.value ==='+91'){
                    if(concernMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                    else if(concernMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                } else {
                    if(concernMobileNumber.value.length < 8){
                        formIsValid = false
                        let msg = "Min 8 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                    else if(concernMobileNumber.value.length > 8){
                        formIsValid = false
                        let msg = "Max 8 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                }

                if(fatherCountryCode.value ==='+91'){
                    if(fatherMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                    else if(fatherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                } else {
                    if(fatherMobileNumber.value.length < 8){
                        formIsValid = false
                        let msg = "Min 8 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                    else if(fatherMobileNumber.value.length > 8){
                        formIsValid = false
                        let msg = "Max 8 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                }

                if(motherCountryCode.value ==='+91'){
                    if(motherMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                    else if(motherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                } else {
                    if(motherMobileNumber.value.length < 8){
                        formIsValid = false
                        let msg = "Min 8 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                    else if(motherMobileNumber.value.length > 8){
                    formIsValid = false
                    let msg = "Max 8 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                }

                if(whatsappCountryCode.value ==='+91'){
                    if(whatsappNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                    else if(whatsappNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                } else {
                    if(whatsappNumber.value.length < 8){
                        formIsValid = false
                        let msg = "Min 8 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                    else if(whatsappNumber.value.length > 8){
                    formIsValid = false
                    let msg = "Max 8 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                }

                if(operationCountryCode.value ==='+91'){
                    if(operationMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                    else if(operationMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                }
                else {
                    if(operationMobileNumber.value.length < 8){
                        formIsValid = false
                        let msg = "Min 8 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }   
                    else if(operationMobileNumber.value.length > 8){
                        formIsValid = false
                        let msg = "Max 8 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                }
            }

            else if(country_id ===6){
                if(concernCountryCode.value ==='+91'){
                    if(concernMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                    if(concernMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                } else {
                    if(concernMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                    else if(concernMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                }

                if(fatherCountryCode.value ==='+91'){
                    if(fatherMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                    if(fatherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                }
                else {
                    if(fatherMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }   
                    else if(fatherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                            setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                }

                if(motherCountryCode.value ==='+91'){
                    if(motherMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                    else if(motherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                }
                else {
                    if(motherMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                    else if(motherMobileNumber.value.length > 10){
                    formIsValid = false
                    let msg = "Max 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                }

                if(whatsappCountryCode.value ==='+91'){
                    if(whatsappNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                    else if(whatsappNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                }
                else {
                    if(whatsappNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                    else if(whatsappNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                }

                if(operationCountryCode.value ==='+91'){
                    if(operationMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                    else if(operationMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                }
                else {
                    if(operationMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                    else if(operationMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                            setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }  
                }
            }
    
            else if(country_id ===7){

                if(concernCountryCode.value ==='+91'){
                    if(concernMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                    else if(concernMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                }
                else {
                    if(concernMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                    else if(concernMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setConcernMobileNumber({ ...concernMobileNumber, error: msg })
                    }
                }

                if(fatherCountryCode.value ==='+91'){
                    if(fatherMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                    else if(fatherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                }
                else {
                    if(fatherMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }
                    else if(fatherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setFatherMobileNumber({ ...fatherMobileNumber, error: msg })
                    }  
                }

                if(motherCountryCode.value ==='+91'){
                    if(motherMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                    else if(motherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                }
                else {
                    if(motherMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                    else if(motherMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setMotherMobileNumber({ ...motherMobileNumber, error: msg })
                    }
                }

                if(whatsappCountryCode.value ==='+91'){
                    if(whatsappNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                    else if(whatsappNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                }
                else {
                    if(whatsappNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }
                    else if(whatsappNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setWhatsappNumber({ ...whatsappNumber, error: msg })
                    }  
                }

                if(operationCountryCode.value ==='+91'){
                    if(operationMobileNumber.value.length < 10){
                        formIsValid = false
                        let msg = "Min 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                    else if(operationMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                }
                else {
                    if(operationMobileNumber.value.length < 9){
                        formIsValid = false
                        let msg = "Min 9 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                    else if(operationMobileNumber.value.length > 10){
                        formIsValid = false
                        let msg = "Max 10 Digit Length"
                        setOperationMobileNumber({ ...operationMobileNumber, error: msg })
                    }
                }
            }


        if(formIsValid){
            setFatherName({...fatherName,error:''})
            setMotherName({...motherName,error:''})
            setFatherEmailAddress({...fatherEmailAddress,error:''});
            setMotherEmailAddress({...motherEmailAddress,error:''});
            setFatherMobileNumber({...fatherMobileNumber,error:''});
            setMotherMobileNumber({...motherMobileNumber,error:''});
            setWhatsappNumber({...whatsappNumber,error:''});
            setFatherProfession({...fatherProfession,error:''});
            setMotherProfession({...motherProfession,error:''});
            setMotherDesignation({...motherProfession,error:''});
            setFatherDesignation({...fatherDesignation,error:''});
            setMotherOrganization({...motherOrganization,error:''});
            setFatherOrganization({...fatherOrganization,error:''});
            setConcernMobileNumber({...concernMobileNumber,error:''});
            setOperationMobileNumber({...operationMobileNumber,error:''});
        }
        
        return formIsValid;
    }

    const submitFormHandler = async(e) => {
        e.preventDefault();
        if(validation()){
            setLoading(true)

            const data = {
                id:userDetail?.id,
                father_name:fatherName.value,
                mother_name:motherName.value,
                parent_email:fatherEmailAddress.value,
                mother_email:motherEmailAddress.value,
                parent_mobile:fatherMobileNumber.value,
                mother_mobile:motherMobileNumber.value,
                whatsapp_number:whatsappNumber.value,
                mother_profession:motherProfession.value,
                mother_designation:motherDesignation.value,
                mother_company_name:motherOrganization.value,
                parent_profession:fatherProfession.value,
                parent_designation:fatherDesignation.value,
                parent_company_name:fatherOrganization.value,
                concerned_mobile_no:concernMobileNumber.value,
                operational_mobile_no:operationMobileNumber.value,
                concerned_country_code:concernCountryCode.value,
                operational_country_code:operationCountryCode.value,
                whatsapp_country_code:whatsappCountryCode.value,
                parent_country_code:fatherCountryCode.value,
                mother_country_code:motherCountryCode.value,
            }

            try {
                await upadateProfileDetail(data).then((res) => {
                    if(res.status){
                        setLoading(false);
                        setUserDetail({...userDetail,...res?.data})
                        swal(res?.message,'','success').then(() => {
                            nexTabChange()
                        })
                    }
                    else{
                        setLoading(false);
                        swal(res?.message,'','error')
                    }
                })
            } catch (error) {
                console.log('update profile..',error)
            }
        }
              
    }

  return (
        <form onSubmit={submitFormHandler} className="row mt-3 gx-lg-5">
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Father's Name<span>*</span></label>
                    <input type="text" value={fatherName.value} 
                   
                    onChange={e => {
                        let value = e.target.value
                        value = value.replace(/[^A-Za-z- ]/ig, '') 
                        setFatherName({...fatherName,value:value,error:''})
                        }
                    } 
                    className="form-control"  placeholder="Father's Name"/>
                    {fatherName.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherName.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Mother's Name<span>*</span></label>
                    <input type="text" value={motherName.value} 
                    onChange={e => {
                        let value = e.target.value
                        value = value.replace(/[^A-Za-z- ]/ig, '') 
                        setMotherName({...motherName,value:value,error:''})
                        }
                    }  
                    
                    className="form-control"  placeholder="Mother's Name"/>
                    {motherName.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherName.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Father's Email Address<span>*</span></label>
                    <input type="email" value={fatherEmailAddress.value} onChange={e => setFatherEmailAddress({...fatherEmailAddress,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>
                    {fatherEmailAddress.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherEmailAddress.error}</small>}

                </div>
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Mother's Email Address<span>*</span></label>
                    <input type="email" value={motherEmailAddress.value} onChange={e => setMotherEmailAddress({...motherEmailAddress,value:e.target.value,error:''})} className="form-control"  placeholder="example@gmail.com"/>
                    {motherEmailAddress.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherEmailAddress.error}</small>}

                </div>

                <div className="col-md-6 mb-3">

                    <label className="form-label">Father's Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            <select onChange={(e) => setFatherCountryCode({...fatherCountryCode,value:e.target.value, error:''})} value={fatherCountryCode.value} className='form-control'>
                                <option value="">Select</option>
                                {countryCode?.map((item => (
                                        <option value={item.isd_code}   key={item.id}>{item.isd_code}</option>
                                )))}
                            </select>
                        </div>
                        <div className="col-10">
                            <input type="text" value={fatherMobileNumber.value}  
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setFatherMobileNumber({...fatherMobileNumber,value:value,error:''})
                            }}
                            className="form-control" placeholder="Enter mobile number"/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        {fatherCountryCode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherCountryCode.error}</small>}
                        {fatherMobileNumber.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherMobileNumber.error}</small>}
                    </div>

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Mother's Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            <select onChange={(e) => setMotherCountryCode({...motherCountryCode,value:e.target.value, error:''})} value={motherCountryCode.value || ''} className='form-control'>
                                <option value="">Select</option>
                                {countryCode?.map((item => (
                                        <option value={item.isd_code}  key={item.id}>{item.isd_code}</option>
                                )))}
                            </select>
                        </div>
                        <div className="col-10">
                            <input type="text" value={motherMobileNumber.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setMotherMobileNumber({...motherMobileNumber,value:value,error:''})
                            }} 
                            className="form-control" placeholder="Enter mobile number"/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        {motherCountryCode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherCountryCode.error}</small>}
                        {motherMobileNumber.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherMobileNumber.error}</small>}
                    </div>

                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">WhatsApp Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            <select onChange={(e) => setWhatsappCountryCode({...whatsappCountryCode,value:e.target.value, error:''})} value={whatsappCountryCode.value || ''} className='form-control'>
                                <option value="">Select</option>
                                {countryCode?.map((item => (
                                        <option value={item.isd_code}  key={item.id}>{item.isd_code}</option>
                                )))}
                            </select>
                        </div>
                        <div className="col-10">
                            <input type="text" value={whatsappNumber.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setWhatsappNumber({...whatsappNumber,value:value,error:''})
                            }} 
                            className="form-control" placeholder="Enter whatsapp number"/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        {whatsappCountryCode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{whatsappCountryCode.error}</small>}
                        {whatsappNumber.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{whatsappNumber.error}</small>}
                    </div>

                </div>

                <div className="col-md-6 mb-3">
                    <div className="row gx-3">
                        <div className="col-lg-6">
                            <label className="form-label">Mother's Profession<span>*</span></label>
                            <input type="text" value={motherProfession.value} onChange={e => setMotherProfession({...motherProfession,value:e.target.value,error:''})} placeholder="Enter Mother's Profession"  className="form-control" />
                            {motherProfession.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherProfession.error}</small>}

                        </div>

                        <div className="col-lg-6 mt-2 mt-lg-0">
                            <label className="form-label">Mother's Designation<span>*</span></label>
                            <input type="text" value={motherDesignation.value} onChange={e => setMotherDesignation({...motherDesignation,value:e.target.value,error:''})} placeholder="Enter Mother's Designation"  className="form-control" />
                            {motherDesignation.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherDesignation.error}</small>}

                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row gx-3">
                        <div className="col-lg-6">
                            <label className="form-label">Father's Profession<span>*</span></label>
                            <input type="text" value={fatherProfession.value} onChange={e => setFatherProfession({...fatherProfession,value:e.target.value,error:''})} placeholder="Enter Father's Profession"  className="form-control" />
                            {fatherProfession.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherProfession.error}</small>}

                        </div>

                        <div className="col-lg-6 mt-2 mt-lg-0">
                            <label className="form-label">Father's Designation<span>*</span></label>
                            <input type="text" value={fatherDesignation.value} onChange={e => setFatherDesignation({...fatherDesignation,value:e.target.value,error:''})} placeholder="Enter Father's Designation"  className="form-control" />
                            {fatherDesignation.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherDesignation.error}</small>}

                        </div>
                    </div>
                </div>

            
                <div className="col-md-6 mb-3">
                    <label  className="form-label">Mother's Organization/Company Name<span>*</span></label>
                    <input type="text" value={motherOrganization.value} onChange={e => setMotherOrganization({...motherOrganization,value:e.target.value,error:''})} className="form-control" placeholder="Organization/Company Name"/>
                    {motherOrganization.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{motherOrganization.error}</small>}

                </div>

                <div className="col-md-6 mb-3">
                    <label  className="form-label">Father's Organization/Company Name<span>*</span></label>
                    <input type="text" value={fatherOrganization.value} onChange={e => setFatherOrganization({...fatherOrganization,value:e.target.value,error:''})} className="form-control" placeholder="Organization/Company Name"/>
                    {fatherOrganization.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{fatherOrganization.error}</small>}

                </div>
                <div className="w-100"></div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Concern Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            <select onChange={(e) => setConcernCountryCode({...concernCountryCode,value:e.target.value, error:''})} value={concernCountryCode.value || ''} className='form-control'>
                                <option value="">Select</option>
                                {countryCode?.map((item => (
                                        <option value={item.isd_code}  key={item.id}>{item.isd_code}</option>
                                )))}
                            </select>
                        </div>
                        <div className="col-10">
                            <input type="text" inputMode='numeric'  value={concernMobileNumber.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setConcernMobileNumber({...concernMobileNumber,value:value,error:''})
                            }} 
                            className="form-control" placeholder="Enter concern mobile number"/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        {concernCountryCode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{concernCountryCode.error}</small>}
                        {concernMobileNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{concernMobileNumber.error}</small>}
                    </div>
                    
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Operation Mobile Number<span>*</span></label>
                    <div className="row gx-1">
                        <div className="col-2">
                            <select onChange={(e) => setOperationCountryCode({...operationCountryCode,value:e.target.value, error:''})} value={operationCountryCode.value || ''}  className='form-control'>
                                <option value="">Select</option>
                                {countryCode?.map((item => (
                                        <option value={item.isd_code}  key={item.id}>{item.isd_code}</option>
                                )))}
                            </select>
                        </div>
                        <div className="col-10">
                            <input type="text" inputMode='numeric'  value={operationMobileNumber.value} 
                            onChange={(e) =>{
                                let value = e.target.value
                                value = value.replace(/\D/g, '')   
                                setOperationMobileNumber({...operationMobileNumber,value:value,error:''})
                            }} 
                            className="form-control" placeholder="Enter operation mobile number"/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-1">
                        {operationCountryCode.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{operationCountryCode.error}</small>}
                        {operationMobileNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{operationMobileNumber.error}</small>}
                    </div>
                </div>

                <div className="col-md-12 mt-2">
                {loading ? <button className="btn btn-default" disabled type="button">
                    <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                        Updating...</button>:<button type="submit" className="btn btn-default">Save & Next</button>}
                {/* <button className="btn btn-default ms-2" onClick={e => nexTabChange()} type="button">Next</button> */}
                </div>


        </form>
  )
}

export default FamilyInfo